import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Wallet } from 'lucide-react';
// import services
import { getWithdrawHistory } from '../services/user.service';
// import custom components
import DataTable from '../custom/DataTable';
import { dateTimeFormat } from '../lib/dateHelper';

const WithdrawHistory = () => {

    // hooks
    const navigate = useNavigate();
    const columns = [
        {
            key: "week",
            text: "Week",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "txid",
            text: "Txid",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "userCode",
            text: "User Id",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "totalAmount",
            text: "Total Amount",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "fee",
            text: "Fee (5%)",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "gst",
            text: "GST (5%)",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "withdrawAmount",
            text: "Withdraw Amount",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "status",
            text: "Status",
            className: "text-left",
            align: "left",
            sortable: false
        },
        {
            key: "createdAt",
            text: "Created At",
            className: "text-left",
            align: "left",
            sortable: false,
            cell: ({ createdAt }) => {
                return dateTimeFormat(createdAt);
            }
        }
    ];
    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, search: "" });
    const [showModal, setShowModal] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getWithdrawHistory(pagination);
            setLoader(false);
            if (status === true) {
                setData(result.data)
                setCount(result.count)
            }
        } catch (err) {
            setLoader(false);
        }
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [pagination])

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 p-4 md:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full">
                                <Wallet className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Withdraw History</h1>
                                {/* <p className="text-gray-600 text-sm">Manage and view all pin numbers</p> */}
                            </div>
                        </div>
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    count={count}
                    loader={loader}
                    setPagination={setPagination}
                />
            </div>
        </div>
    );
};

export default WithdrawHistory;